import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Location } from "../../../@types/location";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const assignFormToLocation = createAsyncThunk(
  "templateDetail/assignFormToLocation",
  async (location: Location, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const { data } = await axiosInstance.post(`${api.baseURL}formsubmitted`, {
        form: state.templateDetail.template.id,
        location: location.id,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
